import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TextBuildingServicesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-building-services',
  templateUrl: 'text-building-services.html',
})
export class TextBuildingServicesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TextBuildingServicesPage');
  }

}



// WEBPACK FOOTER //
// /src/pages/textPages/text-building-services/text-building-services.ts